import CityPageTemplate from "../city-template/CityPageTemplate";
import { smyrnaDeConfig } from "./data";

export default function SmyrnaDePage() {
  return <CityPageTemplate config={smyrnaDeConfig} />;
}